export default __webpack_public_path__ + "public/fonts/lato-v22-latin-700.woff";